import React, { useState, useEffect, Suspense, lazy } from 'react';
import LazyLoad from 'react-lazy-load';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import ImageFactory from '../../adapters/cloudinary/ImageFactory';
import Block from '../../adapters/helpers/Block'
import { IArticleOverview } from '../../types'
import { AdditionalReadingBlockConstants, CarouselBlockConstants, ComponentFactoryConstants } from '../../adapters/helpers/Constants'
import Link from 'next/link';
import Image from 'next/image';
import { mediaQueryHOC } from '../../adapters/helpers/Hooks';
const Heading = lazy(() => import('../Heading/Heading'));
const Loader = lazy(() => import('../../adapters/helpers/Loader'));
import { optimizeImage } from '../../adapters/helpers/pagespeedHelper';

const IAdditionalReadingProps = {
    contentType: PropTypes.oneOf([AdditionalReadingBlockConstants.additionalReadingBlock]),
    className: PropTypes.string,
    classNames: PropTypes.string, // contentful misspelling
    name: PropTypes.string,
    title: PropTypes.string,
    anchorId: PropTypes.string,
    isLegacyLayout: PropTypes.bool,
    articles: PropTypes.arrayOf(IArticleOverview),
};

function AdditionalReadingBlock(props) {
    const { extraAttributes } = props;

    const [fieldState, setfieldState] = useState()
    let block
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            block = new Block(props)
            setfieldState(block.getFields())
        }, 2500);
        return () => clearTimeout(timeoutId);
    }, [fieldState])
    return (
        <Suspense fallback={<Loader />}>
        <LazyLoad offset={100}>
            <>
            {fieldState && <AdditionalReading 
                    {...fieldState}
                    anchorId={block && block.getAnchorId()}
                    articles={extraAttributes?.entity?.relatedArticles} {...props}
                />
            }
            </>
        </LazyLoad>
    </Suspense>
    );
}

AdditionalReadingBlock.propTypes = {
    document: PropTypes.shape({
        fields: PropTypes.exact(IAdditionalReadingProps),
    }),
    extraAttributes: PropTypes.shape({
        entity: PropTypes.shape({
            relatedArticles: PropTypes.arrayOf(IArticleOverview),
        }),
    }),
};

export function AdditionalReading(props) {
    const { classNames, className = classNames, carouselSettings, rightArrowIcon, leftArrowIcon, articlesInCarousal = false } = props;
    const { title, anchorId, articles, isLegacyLayout, isSmall } = props;
    const [sliderSettings, setSliderSettings] = useState({
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000,
        infinite: true,
        lazyLoad: false,
        autoplay: false,
        prevArrow: false,
        nextArrow: false,
        autoplaySpeed: 6000,
        dots: false,
        centerMode: true,
        centerPadding: '20px',
        nextArrow: <img tabIndex={0} src={optimizeImage(rightArrowIcon?.fields?.file?.url)} data-action-detail='carousel-next-arrow' alt={CarouselBlockConstants.rightArrow} fetchPriority="high" />,
        prevArrow: <img tabIndex={0} src={optimizeImage(leftArrowIcon?.fields?.file?.url)} data-action-detail='carousel-previous-arrow' alt={CarouselBlockConstants.leftArrow} fetchPriority="high" />,
    })

    const hideAriaHiddenTiles = () => {
        Array.from(document.querySelectorAll('.slick-slide')).forEach((slide) => {
            slide.setAttribute('aria-hidden', 'false')
        })
    }

    useEffect(() => {
        hideAriaHiddenTiles()
        const screenWidth = window.innerWidth
        const breakpoints = [
            { max: 360, padding: '28px' },
            { max: 376, padding: '35px' },
            { max: 390, padding: '40px' },
            { max: 414, padding: '53px' },
            { max: 430, padding: '60px' },
        ]
        const breakpoint = breakpoints.find((b) => screenWidth <= b.max) || { padding: '40px' }
        setSliderSettings({ ...sliderSettings, ...(carouselSettings || {}), fieldsCenterPadding: breakpoint.padding })
    }, [])

    if (!articles || articles.length === 0) {
        return null;
    }

    const variationB = (articles.length <= 2);
    articles.map((article) => {
        if (article.fields?.slug == null) {
            console.info('SLUG IS NULL FOR ', article?.fields?.name);
        }
    })

    const renderArticleList = () => {
        return articles.map((article, i) => {
            const contentThumbnail = article.fields?.thumbnailImage?.fields?.asset?.fields?.file?.url
            if (article.fields?.slug != null) {
                return (
                    <li className='ob-additional-reading__item' key={i}>
                        <Link className='ob-additional-reading__item-link event_internal_link' data-action-detail={article.fields?.slug?.fields?.slug} href={article.fields?.slug?.fields?.slug}>
                            <div className='ob-additional-reading__item-image'>
                                {!!contentThumbnail && (
                                    <LazyLoad
                                        offset={100}
                                        placeholder={
                                            <picture className='ob-additional-reading__item-pic'>
                                                <img
                                                className='ob-additional-reading__item-img'
                                                alt={`${article.fields?.title} ${AdditionalReadingBlockConstants.articleLink}`} 
                                                height={150}
                                                priority={true}
                                            />
                                            </picture>
                                        }>
                                        <picture className='ob-additional-reading__item-pic'>
                                            {variationB && <source media={ComponentFactoryConstants.mediaUpper} srcSet={ImageFactory.imageContentfullDpr(contentThumbnail, ComponentFactoryConstants.dprUpper)} />}

                                            <source
                                                media={articlesInCarousal ? ComponentFactoryConstants.mediaLowerMobile : ComponentFactoryConstants.mediaLower}
                                                srcSet={ImageFactory.imageContentfullDpr(contentThumbnail, ComponentFactoryConstants.dprMedium)}
                                            />
                                            <source srcSet={ImageFactory.imageContentfullDpr(contentThumbnail, ComponentFactoryConstants.dprAuto)} />

                                            <Image
                                                className='ob-additional-reading__item-img'
                                                alt={`${article.fields?.title} ${AdditionalReadingBlockConstants.articleLink}`}
                                                src={optimizeImage(ImageFactory.imageContentfullSrc(contentThumbnail, ComponentFactoryConstants.dprUpper))}
                                                srcSet={optimizeImage(ImageFactory.imageContentfullDpr(contentThumbnail, ComponentFactoryConstants.dprUpper))}
                                                width={0}
                                                height={0}
                                                sizes="(max-width: 768px) 50vw (max-width: 1200px) 100vw 70vw"
                                                style={{ width: 'auto', height: 'auto' }} // optional
                                                priority={true}
                                            />

                                        </picture>
                                    </LazyLoad>
                                )}
                            </div>

                            <div className='ob-additional-reading__item-info'>
                                <div className='ob-additional-reading__item-title'>{article.fields?.title}</div>

                                {!!article.fields?.readTime && <div className='ob-additional-reading__item-time'>{article.fields?.readTime} min read</div>}
                            </div>
                        </Link>
                    </li>
                );
             } else {
                return '';
            }
        })
    }
    return (
        <div className={`ob-additional-reading ${isLegacyLayout ? `ob-additional-reading__legacy` : ''} ${variationB ? `ob-additional-reading--wide` : ''} ${className || ''}`} id={anchorId}>
            <Suspense fallback={<Loader/>}>
            <Heading className='ob-additional-reading__heading'>{title}</Heading>
            </Suspense>
            <Suspense fallback={<Loader />}>
            <div className='ob-additional-reading__articles'>
                <ul className='ob-additional-reading__list'>{isSmall && articlesInCarousal ? <Slider {...sliderSettings}>{renderArticleList()}</Slider> : renderArticleList()}</ul>
            </div>
            </Suspense>
        </div>
    );
}

export default mediaQueryHOC(AdditionalReadingBlock);
AdditionalReading.propTypes = IAdditionalReadingProps;
